import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export const useDeadlineWarning = (endDate: string | null | undefined): string | null => {
    const { t } = useTranslation();

    if (!endDate) return null;

    const today = dayjs().startOf('day');
    const end = dayjs(endDate).startOf('day');
    const daysLeft = end.diff(today, 'day');

    if (daysLeft < 0) return t('deadline_is_overdue');
    if (daysLeft === 0) return t('expires_today');
    if (daysLeft <= 3) return t('days_left_until_the_due_date', { count: daysLeft });

    return null;
};
